import { OktaAuth } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { useIframeInitialization } from "@src/features/iframe";
import { navigation } from "@src/navigation";
import { useOktaAuthInstance } from "@src/okta/auth";
import { RouterBridge } from "@src/providers/routerBridge";
import { Outlet, useNavigate } from "react-router-dom";

/**
 * Root route component that wraps all routes with Okta Security.
 * This component is inside RouterProvider, so it can use useNavigate().
 */
export default function Root() {
  const navigate = useNavigate();
  const oktaAuth = useOktaAuthInstance();

  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri?: string) => {
    navigate(originalUri || navigation.dashboard(), { replace: true });
  };

  useIframeInitialization();

  return (
    <>
      <RouterBridge />
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Outlet />
      </Security>
    </>
  );
}
